const ca = {
  services: {
    seoTitle: "Serveis · Hotel Ciutat Martorell a Martorell",
    seoDesc: "Tots els serveis de l'hotel i de les habitacions: Business Corner, restaurant My Bar, pàrquing, gimnàs, WiFi gratuït, recepció 24 h i molt més.",
    eyebrow: "Serveis",
    title: "Tot el que necessites per a una estada còmoda",
    hotelTitle: "Serveis de l'hotel",
    hotel: [
      "Aire condicionat i calefacció",
      "Ascensors",
      "Bufet d'esmorzar diari",
      "Business Corner",
      "Consigna d'equipatges",
      "Gimnàs",
      "Material audiovisual",
      "Pàrquing",
      "Recepció 24 h",
      "Restaurant My Bar, obert cada dia per a dinars i sopars",
      "Servei d'habitacions 24 h",
      "Sales de reunió i banquets",
      "Servei de bugaderia / tintoreria",
      "Servei d'impressió",
      "WiFi gratuït",
    ],
    roomsTitle: "A l'habitació",
    rooms: [
      "Adaptades a persones amb mobilitat reduïda",
      "Aire condicionat i calefacció individual",
      "Amenities al bany",
      "Bany complet amb dutxa o banyera i/o bidet",
      "Escriptori",
      "Minibar",
      "Assecador de cabell",
      "Televisió pantalla plana amb entrada USB",
      "Telèfon a l'habitació i al bany",
      "WiFi gratuït",
      "Bressol disponible",
      "Llit supletori",
      "Habitacions per a no fumadors",
    ],
    fitness: {
      eyebrow: "Gimnàs",
      title: "Sala de fitness",
      text: "Mantén la teva rutina durant la teva estada a la nostra sala de fitness, equipada amb cinta de córrer, bicicleta estàtica i manuelles.",
      alts: ["Sala de fitness amb bicicleta estàtica, cinta de córrer i tovalloles", "Sala de fitness amb cinta de córrer, bicicleta i manuelles davant del mirall"],
    },
    shop: {
      eyebrow: "Productes oficials",
      title: "La passió del futbol, a recepció",
      text: "A la nostra recepció hi trobaràs productes oficials del FC Barcelona i del Reial Madrid. Emporta't la passió del teu equip.",
      note: "Venda exclusiva a recepció",
      cta: "Pregunta a recepció",
      clubs: [
        { name: "FC Barcelona", items: "Samarretes, gorres, bufandes, motxilles, pilotes i molt més." },
        { name: "Reial Madrid", items: "Samarretes, equipacions, gorres, pilotes, bufandes i molt més." },
      ],
    },
  },
  nav: {
    hotel: "L'Hotel",
    rooms: "Habitacions",
    services: "Serveis",
    corporate: "Empreses & Sales",
    events: "Esdeveniments & Bodes",
    restaurant: "Restaurant",
    location: "Ubicació",
    biosphere: "Sostenibilitat",
    gallery: "Galeria",
    blog: "Blog",
    contact: "Contacte",
    book: "Reservar directe",
    menu: "Menú",
    close: "Tancar",
    call: "Trucar",
    map: "Ubicació",
    bookShort: "Reservar",
  },
  hero: {
    availability: "Consultar disponibilitat",
    checkin: "Entrada",
    checkout: "Sortida",
    adults: "Adults",
    children: "Nens",
    promo: "Codi promo",
    promoPlaceholder: "Opcional",
    bestPrice: "Millor preu garantit reservant aquí",
    scroll: "Desplaça't",
  },
  attrs: [
    { t: "Millor preu garantit", d: "Reservant directe" },
    { t: "Cancel·lació flexible", d: "Segons tarifa" },
    { t: "Esmorzar bufet", d: "De 06:30 a 10:30" },
    { t: "Pàrquing privat", d: "Amb suplement, segons disponibilitat" },
    { t: "100 m Renfe & FGC", d: "30 min Barcelona" },
  ],
  marquee: ["Martorell", "30 min Barcelona", "Montserrat", "Renfe & FGC a 100 m", "Zona empresarial SEAT-CUPRA", "Confort 4 estrelles", "92 habitacions", "Reserva directa"],
  home: {
    presEyebrow: "L'hotel",
    stats: [
      { n: "92", l: "habitacions standard" },
      { n: "100 m", l: "de Renfe i FGC" },
      { n: "30 min", l: "de Barcelona i l'aeroport" },
      { n: "180", l: "persones al saló principal" },
    ],
    roomsEyebrow: "Habitacions",
    roomsTitle: "Descans a mida",
    roomsText: "Dues tipologies pensades per al viatger de negocis, les famílies i les estades llargues.",
    roomsCta: "Veure totes les habitacions",
    from: "Des de",
    detail: "Veure detall",
    corpEyebrow: "Empreses & reunions",
    corpTitle: "Un hub corporatiu|a 5 minuts de SEAT-CUPRA",
    corpFeatures: ["3 sales de reunions", "Fins a 180 persones", "Connexió WiFi i material audiovisual", "Coffee breaks i dinars executius"],
    corpCta: "Sol·licitar pressupost",
    corpSecondary: "Veure sales",
    restEyebrow: "Gastronomia",
    restCta: "Descobrir el restaurant",
    locEyebrow: "Ubicació",
    locCta: "Com arribar",
    galleryEyebrow: "Galeria",
    galleryCta: "Veure galeria completa",
    directEyebrow: "Reserva directa",
    directTitle: "Reservar aquí sempre surt a compte",
    directItems: [
      { t: "Millor preu online", d: "Cap agència t'oferirà una tarifa més baixa que el nostre web." },
      { t: "Condicions flexibles", d: "Tarifes amb cancel·lació gratuïta i pagament a l'hotel." },
      { t: "Atenció directa", d: "Parles amb l'equip de l'hotel, sense intermediaris, abans i després de la teva estada." },
      { t: "Detalls de benvinguda", d: "Late check-out subjecte a disponibilitat i avantatges exclusius per a clients directes." },
    ],
    testimonialsEyebrow: "Opinions",
    testimonials: [
      { q: "Ubicació perfecta per treballar a la zona industrial. Habitacions silencioses i esmorzar complet. Repetim cada mes.", a: "Marc V.", r: "Viatge d'empresa" },
      { q: "Vam celebrar la comunió de la nostra filla al saló i tot va sortir impecable. L'equip es va ocupar de cada detall.", a: "Laura & Jordi", r: "Celebració familiar" },
      { q: "Tren a 2 minuts a peu i Barcelona en mitja hora. Una base tranquil·la i ben cuidada per visitar la ciutat i Montserrat.", a: "Claire D.", r: "Escapada" },
    ],
    contactEyebrow: "Parlem-ne",
    contactCta: "Contactar",
    rfpCta: "Demanar pressupost",
  },
  rooms: {
    eyebrow: "Habitacions",
    surface: "Superfície",
    occupancy: "Ocupació",
    bed: "Llit",
    bath: "Bany",
    features: "Equipament",
    guests: "persones",
    book: "Reservar aquesta habitació",
    all: "Totes les habitacions",
    photosEyebrow: "Galeria",
    photosTitle: "Habitació i bany",
    photosCount: "fotos",
    featureLabels: {
      wifi: "Wifi d'alta velocitat",
      ac: "Climatització",
      tv: "TV",
      desk: "Escriptori de treball",
      minibar: "Minibar",
      hairdryer: "Assecador de cabell",
      crib: "Bressol disponible",
      extra_bed: "Llit supletori",
      accessible: "Adaptada",
      nonsmoking: "No fumadors",
    },
    servicesEyebrow: "Serveis",
    family: {
      eyebrow: "Viatges en família",
      title: "Opcions per a famílies",
      beds: { t: "Llit supletori (triple)", d: "Converteix la teva habitació en triple amb un llit supletori. Gratuït per a menors de 12 anys." },
      crib: { t: "Bressol gratuït", d: "Bressols disponibles sense cost per als més petits." },
      note: "Ambdues opcions estan subjectes a disponibilitat; sol·licita-les amb antelació en reservar.",
    },
    servicesTitle: "Tenim tot el que necessites",
    services: [
      { t: "Esmorzar bufet", d: "Producte local, brioixeria artesana i opcions saludables cada matí." },
      { t: "Pàrquing privat", d: "Amb suplement, segons disponibilitat." },
      { t: "Wifi de fibra", d: "Connexió simètrica a tot l'hotel, sense cost addicional." },
      { t: "Recepció 24 h", d: "Equip disponible a qualsevol hora per al que necessitis." },
      { t: "Sala de Fitness", d: "Mantén la teva rutina durant la teva estada." },
      { t: "Restaurant & bar", d: "Menú executiu, carta mediterrània i copes tranquil·les." },
    ],
    notFound: "Habitació no trobada",
  },
  corporate: {
    eyebrow: "Empreses",
    title: "La vostra base d'operacions al corredor industrial del Llobregat",
    pillars: [
      { t: "Tarifes corporatives", d: "Preus negociats per a empreses amb estades freqüents i facturació centralitzada." },
      { t: "Sales de reunions", d: "Tres espais modulables, de 12 a 180 persones." },
      { t: "Treballar i descansar", d: "Escriptori a totes les habitacions, Wifi i esmorzar des de primera hora." },
      { t: "Càtering executiu", d: "Coffee breaks, dinars de treball i sopars d'equip al mateix hotel." },
    ],
    salasEyebrow: "Sales de reunions",
    photosTitle: "Sala i esdeveniments",
    salasTitle: "Espais que s'adapten a la vostra agenda",
    salasCta: "Veure totes les sales i capacitats",
    formEyebrow: "Tarifa empresa",
    formTitle: "Sol·liciteu la vostra tarifa corporativa",
    formText: "Expliqueu-nos quantes nits a l'any necessita el vostre equip i us prepararem una proposta en menys de 24 hores.",
    capacityTitle: "Capacitats per muntatge",
    capacityLabels: { teatro: "Teatre", escuela: "Escola", u: "Forma U", imperial: "Imperial", coctel: "Còctel", banquete: "Banquet" },
    equipmentLabels: {
      wifi: "Wifi de fibra", proyector: "Projector & pantalla", flipchart: "Flipchart", pizarra: "Pissarra",
      coffee_break: "Coffee break", agua: "Aigua mineral", escritura: "Material d'escriptura", luz_natural: "Llum natural", panelable: "Panelable",
    },
    area: "Superfície",
    people: "pers.",
    upTo: "Fins a",
    requestRoom: "Sol·licitar pressupost d'aquesta sala",
    salasIntro: "Totes les sales disposen de wifi de fibra, climatització independent, equipament audiovisual i servei de coffee break. Us ajudem a triar el muntatge ideal.",
    servicesTitle: "Serveis per al vostre esdeveniment",
    services: ["Coffee break de benvinguda i mig matí", "Dinar executiu o bufet de treball", "Allotjament per a ponents i assistents", "Pàrquing per a assistents", "Suport tècnic durant l'esdeveniment", "Secretaria i material d'escriptura"],
    otherRooms: "Altres sales",
    notFound: "Sala no trobada",
  },
  events: {
    eyebrow: "Esdeveniments & celebracions",
    title: "Els grans dies mereixen un lloc a l'alçada",
    intro: "Bodes, comunions, aniversaris i trobades de grup en un saló de 220 m² amb llum natural, cuina pròpia i 92 habitacions perquè ningú no hagi de conduir de tornada.",
    types: [
      { key: "weddings", t: "Bodes", d: "Banquets de fins a 150 convidats, còctel de benvinguda i habitació nupcial de cortesia.", cta: "Descobrir bodes" },
      { key: "celebrations", t: "Celebracions", d: "Comunions, bateigs, aniversaris amb menús a mida per a totes les edats.", cta: "Veure celebracions" },
      { key: "groups", t: "Grups", d: "Equips esportius, viatges organitzats i pelegrins a Montserrat amb condicions especials.", cta: "Grups & viatges" },
    ],
    stepsEyebrow: "Com ho fem",
    steps: [
      { t: "Ens coneixem", d: "Visita a l'hotel, escoltem la vostra idea i proposem espais i menús." },
      { t: "Proposta a mida", d: "Pressupost tancat en 48 h, sense sorpreses, amb degustació prèvia per a bodes." },
      { t: "El gran dia", d: "Un coordinador dedicat s'ocupa dels temps, proveïdors i que només hàgiu de gaudir." },
    ],
    formEyebrow: "Expliqueu-nos el vostre esdeveniment",
    formTitle: "Comencem a planificar-lo",
    weddings: {
      title: "Bodes a Martorell, a mitja hora de Barcelona",
      intro: "Un saló panelable amb llum natural per al banquet, terrassa per al còctel i habitacions per als nuvis i els seus convidats. Cuina mediterrània pròpia i un coordinador dedicat des del primer cafè fins a l'últim ball.",
      includes: ["Còctel de benvinguda", "Banquet amb menú degustació previ", "Habitació nupcial de cortesia", "Tarifes especials per a convidats", "Barra lliure i DJ opcional"],
    },
    celebrations: {
      title: "Comunions, bateigs i aniversaris",
      intro: "Celebracions familiars amb menús pensats per a grans i petits, espai per a animació infantil i la tranquil·litat de tenir-ho tot sota el mateix sostre.",
      includes: ["Menús infantils i per a adults", "Espai per a animació", "Decoració a mida", "Pastís personalitzat", "Zona de fotografies", "Habitacions per a familiars"],
    },
    groups: {
      title: "Grups, equips i viatges organitzats",
      intro: "Allotjament per a grups de 10 a 180 persones amb esmorzar anticipat, sopars de grup i check-in àgil. Punt de partida ideal per a Montserrat i Barcelona.",
      includes: ["Tarifes de grup des de 10 habitacions", "Esmorzar anticipat a demanda", "Sopars i pícnics de grup", "Check-in col·lectiu"],
    },
    includesTitle: "Inclòs a la proposta",
    back: "Tots els esdeveniments",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Cuina mediterrània de mercat",
    hoursTitle: "Horaris",
    breakfast: "Esmorzar",
    lunch: "Dinar",
    dinner: "Sopar",
    menuEyebrow: "Propostes",
    menus: [
      { t: "Esmorzar bufet", d: "Brioixeria artesana, fruita fresca, embotits catalans, ous al moment i cafè d'especialitat.", p: "06:30 – 10:30" },
      { t: "Menú executiu", d: "De dilluns a divendres al migdia. Tres plats de mercat amb pa, beguda i cafè.", p: "Consultar preu" },
      { t: "Carta mediterrània", d: "Arrossos, peix del dia, carns a la brasa i postres de la casa amb vins del Penedès.", p: "Sopars i caps de setmana" },
      { t: "Menús de grup", d: "Propostes tancades per a empreses, celebracions i grups de viatge a partir de 10 comensals.", p: "A mida" },
    ],
    reserveTitle: "Reservar taula",
    reserveText: "Truca'ns i et confirmem la taula a l'instant.",
    reserveCta: "Trucar al restaurant",
    reserveTap: "Toca per trucar",
    wineEyebrow: "Celler",
    wineTitle: "Vins del Penedès i de tot Catalunya",
    wineText: "Una carta curta i honesta que prioritza petits cellers de la comarca: caves, xarel·los i garnatxes que acompanyen la cuina de temporada.",
  },
  location: {
    eyebrow: "Ubicació & connectivitat",
    title: "Al centre de tot el que importa",
    pois: [
      { name: "Estació Renfe / FGC Martorell Enllaç", dist: "100 m", time: "2 min a peu", mode: "walk" },
      { name: "Seu SEAT-CUPRA i polígons industrials", dist: "2,5 km", time: "5 min en cotxe", mode: "car" },
      { name: "Monestir i Parc Natural de Montserrat", dist: "19 km", time: "20 min en cotxe / cremallera", mode: "car" },
      { name: "Centre de Barcelona (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 min en tren directe o A-2", mode: "train" },
      { name: "Aeroport Barcelona-El Prat (BCN)", dist: "32 km", time: "25 min per autopista", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 min per AP-7", mode: "car" },
    ],
    faqEyebrow: "Preguntes freqüents",
    faqTitle: "Com arribar i moure's",
    mapCta: "Obrir a Google Maps",
    addressTitle: "Adreça",
    transportTitle: "Transport",
    transportItems: [
      { t: "En tren", d: "Renfe R4 i FGC (Martorell Enllaç / Martorell Central) a 100 m. Barcelona en 30 min." },
      { t: "En cotxe", d: "Sortida directa des de l'A-2 i l'AP-7." },
      { t: "Des de l'aeroport", d: "25 minuts per autopista. Taxi o lloguer de cotxe recomanat." },
    ],
  },
  gallery: {
    eyebrow: "Galeria",
    title: "L'hotel, en imatges",
    all: "Tot",
    cats: { habitaciones: "Habitacions", restaurante: "Restaurant", salas: "Sales de reunions", eventos: "Esdeveniments", fitness: "Sala de fitness", comunes: "Zones comunes" },
  },
  blog: {
    eyebrow: "Blog & guies",
    title: "Martorell, Barcelona i Montserrat amb calma",
    read: "min de lectura",
    readMore: "Llegir article",
    back: "Tornar al blog",
    related: "Articles relacionats",
    notFound: "Article no trobat",
  },
  contact: {
    eyebrow: "Contacte",
    title: "Parlem de la vostra estada o el vostre esdeveniment",
    text: "Responem en menys de 24 hores laborables. Per a reserves d'habitacions, utilitzeu el nostre motor de reserva directa amb el millor preu garantit.",
    phone: "Telèfon",
    email: "Email",
    address: "Adreça",
    hours: "Recepció 24 hores",
    formEyebrow: "Formulari",
    formTitle: "En què us podem ajudar?",
  },
  form: {
    type: "Tipus de sol·licitud",
    types: { contacto: "Consulta general", empresa: "Tarifa corporativa", salas: "Pressupost sales / reunions", evento: "Boda / celebració / grup", restaurante: "Reserva restaurant" },
    name: "Nom i cognoms",
    company: "Empresa / organització",
    email: "Email",
    phone: "Telèfon",
    nights: "Nits a l'any (aprox.)",
    guests: "Persones / comensals",
    date: "Data prevista",
    attendees: "Nombre d'assistents",
    eventType: "Tipus d'esdeveniment",
    eventTypes: ["Boda", "Comunió / bateig", "Aniversari", "Reunió / formació", "Convenció", "Grup de viatge", "Altre"],
    setup: "Muntatge preferit",
    setups: ["Teatre", "Escola", "Forma U", "Imperial", "Còctel", "Banquet"],
    catering: "Càtering",
    caterings: ["Coffee break", "Dinar executiu", "Sopar", "Sense càtering"],
    lodging: "Necessiteu allotjament?",
    lodgings: ["Sí", "No", "Per confirmar"],
    message: "Comentaris",
    messagePlaceholder: "Expliqueu-nos què necessiteu…",
    consent: "He llegit i accepto la política de privacitat i el tractament de les meves dades per atendre aquesta sol·licitud.",
    submit: "Enviar sol·licitud",
    sending: "Enviant…",
    success: "Sol·licitud enviada. Us respondrem en menys de 24 h.",
    error: "No s'ha pogut enviar. Torneu-ho a provar o truqueu-nos.",
    required: "Camp obligatori",
    invalidEmail: "Email no vàlid",
    consentRequired: "Heu d'acceptar la política de privacitat",
    select: "Seleccionar",
  },
  footer: {
    tagline: "Hotel 4 estrelles a Martorell. Descans, treball i celebracions a 30 minuts de Barcelona.",
    explore: "Explorar",
    business: "Empreses",
    guides: "Guies",
    legal: "Legal",
    contact: "Contacte",
    legalNotice: "Avís legal",
    privacy: "Privacitat",
    cookies: "Cookies",
    cookieSettings: "Configurar cookies",
    rights: "Tots els drets reservats.",
    registration: "Registre turístic",
    newsletter: "Rebeu ofertes directes",
    newsletterText: "Només escrivim quan hi ha alguna cosa que val la pena.",
    subscribe: "Subscriure'm",
    subscribed: "Gràcies, us mantindrem informats.",
    directBook: "Reserva directa · Millor preu garantit",
  },
  legal: {
    legal: { title: "Avís legal", date: "octubre de 2026", sections: [
      ["Dades identificatives", "En compliment del que disposa la Llei 34/2002, d'11 de juliol, de serveis de la societat de la informació i de comerç electrònic (LSSI-CE), s'informa de les dades següents:\nTitular: EYE STAR, S.L.\nNom comercial: Hotel Ciutat Martorell\nNIF: B87171740\nDomicili social: Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), Espanya\nDomicili de l'establiment: Avda. Pau Claris, s/n, 08760 Martorell (Barcelona), Espanya\nTelèfon: +34 937 745 160\nCorreu electrònic: info@hotel-martorell.com\nLloc web: www.hotel-martorell.com\nDades registrals: Registre Mercantil de Madrid, Tom 32963, Foli 138, Full M-593334, Inscripció 1a."],
      ["Objecte", "Aquest Avís Legal regula l'accés, la navegació i la utilització del lloc web www.hotel-martorell.com, així com les responsabilitats derivades de la utilització dels seus continguts i, si escau, dels serveis que s'hi puguin oferir.\nL'accés i la navegació pel lloc web atribueixen la condició d'usuari i impliquen l'acceptació de les condicions recollides en aquest Avís Legal."],
      ["Condicions d'ús", "L'usuari es compromet a utilitzar el lloc web de conformitat amb la legislació vigent, la bona fe, l'ordre públic i aquest Avís Legal.\nL'usuari s'ha d'abstenir d'utilitzar el lloc web amb finalitats il·lícites o contràries al que estableix aquest Avís Legal, així com de dur a terme qualsevol actuació que pugui danyar, inutilitzar, sobrecarregar o deteriorar el lloc web, els seus continguts o els sistemes i equips que el suporten."],
      ["Propietat intel·lectual i industrial", "Tots els continguts del lloc web, incloent-hi, a títol enunciatiu i no limitatiu, textos, fotografies, imatges, gràfics, logotips, icones, disseny, estructura, codi font i altres elements que formen part del lloc web, són titularitat d'EYE STAR, S.L. o s'utilitzen amb la corresponent autorització dels seus legítims titulars.\nAquests continguts estan protegits per la normativa vigent en matèria de propietat intel·lectual i industrial.\nQueda prohibida la reproducció, distribució, comunicació pública, transformació o qualsevol altra forma d'explotació, total o parcial, dels continguts del lloc web sense l'autorització prèvia i expressa d'EYE STAR, S.L., llevat dels casos legalment permesos."],
      ["Responsabilitat", "EYE STAR, S.L. procurarà que els continguts del lloc web siguin correctes i estiguin actualitzats. No obstant això, no garanteix la inexistència d'errors o omissions ni es responsabilitza dels danys o perjudicis que es puguin derivar de la utilització de la informació continguda al lloc web quan aquests siguin conseqüència de circumstàncies alienes al seu control.\nEYE STAR, S.L. tampoc no garanteix la disponibilitat i continuïtat del funcionament del lloc web, i es poden produir interrupcions per causes tècniques, de manteniment o per circumstàncies alienes al seu control.\nEl lloc web pot contenir enllaços a pàgines web de tercers. EYE STAR, S.L. no assumeix cap responsabilitat pels continguts, serveis, funcionament o polítiques de privacitat d'aquests llocs web externs."],
      ["Protecció de dades personals", "El tractament de les dades personals que es puguin recollir a través d'aquest lloc web es farà de conformitat amb la normativa vigent en matèria de protecció de dades personals.\nLa informació relativa al responsable del tractament, les finalitats del tractament, les bases jurídiques, els destinataris, els terminis de conservació i els drets que poden exercir els usuaris està disponible a la Política de Privacitat del lloc web."],
      ["Cookies", "Aquest lloc web pot utilitzar cookies i tecnologies similars.\nLa informació relativa a les cookies utilitzades, les seves finalitats, els tercers que hi puguin intervenir i la manera com l'usuari pot gestionar les seves preferències està disponible a la Política de Cookies.\nLes cookies que no siguin estrictament necessàries s'utilitzaran de conformitat amb la normativa aplicable i, quan calgui, amb l'obtenció prèvia del consentiment de l'usuari."],
      ["Comunicacions comercials", "Quan l'usuari hagi prestat el seu consentiment per rebre comunicacions comercials per mitjans electrònics, aquestes es faran de conformitat amb la legislació vigent.\nL'usuari es podrà oposar a l'enviament de comunicacions comercials en qualsevol moment mitjançant els mecanismes habilitats a aquest efecte en cada comunicació."],
      ["Modificacions", "EYE STAR, S.L. es reserva el dret de modificar, actualitzar o eliminar, en qualsevol moment i sense necessitat de previ avís, els continguts i serveis oferts a través del lloc web, així com aquest Avís Legal.\nLes modificacions seran aplicables des del moment de la seva publicació al lloc web."],
      ["Legislació aplicable i jurisdicció", "La relació entre EYE STAR, S.L. i l'usuari es regirà per la legislació espanyola.\nPer a la resolució de qualsevol controvèrsia que pugui sorgir en relació amb l'accés o la utilització del lloc web, seran competents els jutjats i tribunals que corresponguin de conformitat amb la normativa aplicable.\nQuan l'usuari tingui la condició de consumidor o usuari, es respectaran les normes imperatives relatives a competència judicial i protecció de consumidors que siguin aplicables."],
    ]},
    privacy: { title: "Política de privacitat", date: "18 de juliol de 2025", sections: [
      ["Responsable del tractament", "Raó social: EYE STAR SL\nNIF: B87171740\nDomini: https://www.hotel-martorell.com/\nAdreça postal: Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nCorreu electrònic: administracion@hotel-martorell.com\nTelèfon: +34 937 745 160"],
      ["Protecció de dades", "De conformitat amb la normativa vigent i aplicable en protecció de dades de caràcter personal, us informem que les vostres dades s'incorporaran al sistema de tractament titularitat d'EYE STAR SL, amb NIF B87171740 i domicili social a Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid). A continuació es facilita la informació dels tractaments realitzats."],
      ["Gestió de reserves en línia d'allotjament", "Finalitat: registre i gestió de les reserves en línia d'allotjament.\nTermini de conservació: 3 anys (Ordre INT/1922/2003, de 3 de juliol, sobre llibres-registre i parts d'entrada de viatgers en establiments d'hostaleria i altres d'anàlegs).\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: nom i cognoms, telèfon, NIF, adreça electrònica, dades econòmiques o d'assegurances.\nDades sensibles: dades relatives a menors.\nCessions: les vostres dades es comunicaran, en cas necessari, a l'Agència Tributària, bancs i caixes, Forces i Cossos de Seguretat i autoritats competents, amb la finalitat de complir les obligacions administratives i de seguretat establertes a la normativa aplicable. La base legitimadora de la cessió és el compliment d'una llei."],
      ["Accions comercials (formulari web)", "Finalitat: captació, registre i tractament de dades per atendre les vostres consultes i/o sol·licituds, així com per a publicitat i prospecció comercial.\nTermini de conservació: mentre es mantingui el consentiment prestat, llevat d'obligació legal.\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: nom i cognoms, adreça electrònica."],
      ["Gestió d'usuaris web", "Finalitat: captació, registre i tractament de dades de l'usuari.\nTermini de conservació: mentre es mantingui el consentiment prestat, llevat d'obligació legal.\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: nom i cognoms, adreça electrònica."],
      ["Instal·lació de cookies", "Finalitat: gestió i instal·lació de les cookies.\nTermini de conservació: mentre es mantingui el consentiment prestat.\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: adreça electrònica, adreça IP."],
      ["Newsletter", "Finalitat: gestió de la subscripció a la newsletter per fer els enviaments corresponents.\nTermini de conservació: mentre es mantingui el consentiment prestat.\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: nom i cognoms, adreça electrònica."],
      ["Gestió del formulari web", "Finalitat: atendre les vostres consultes i/o sol·licituds.\nTermini de conservació: mentre es mantingui el consentiment prestat.\nBase legítima: el consentiment de l'interessat.\nDades bàsiques: nom i cognoms, adreça electrònica, adreça IP."],
      ["Drets dels interessats", "Podeu exercir els drets d'accés, rectificació, limitació, supressió, portabilitat i oposició al tractament de les vostres dades de caràcter personal, així com el dret a no ser objecte de decisions automatitzades (inclosa l'elaboració de perfils) i a retirar el consentiment prestat:\n• Accés: obtenir confirmació sobre si es tracten les vostres dades i, en tal cas, les dades concretes i la informació legal del tractament.\n• Rectificació: que es modifiquin les dades inexactes o incompletes.\n• Limitació: que es limitin les finalitats del tractament en determinats supòsits.\n• Supressió: que se suprimeixin les vostres dades, llevat de les excepcions previstes al RGPD.\n• Portabilitat: rebre les vostres dades en un format estructurat, d'ús comú i lectura mecànica, i transmetre-les a un altre responsable.\n• Oposició: que no es tractin les vostres dades o cessi el seu tractament en els supòsits previstos.\n• A no ser objecte de decisions automatitzades, inclosa l'elaboració de perfils.\n• Retirada del consentiment: en qualsevol moment i de manera gratuïta."],
      ["Exercici dels drets", "Per exercir aquests drets podeu presentar un escrit a l'adreça Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), a l'atenció d'EYE STAR SL, o enviar un correu electrònic a administracion@hotel-martorell.com. L'interessat s'haurà d'identificar fefaentment; en cas de dubtes sobre la seva identitat, se li podrà sol·licitar que esmeni la petició. La sol·licitud la pot fer un representant legal o voluntari degudament identificat i autoritzat. Cal concretar el dret o drets que es volen exercir i indicar una adreça a efectes de notificacions, aportant els documents acreditatius necessaris. Mai no es facilitarà informació per telèfon."],
      ["Reclamació davant l'autoritat de control", "Teniu dret a presentar una reclamació davant l'Agència Espanyola de Protecció de Dades si considereu que un fet pot suposar un incompliment de la normativa aplicable en matèria de protecció de dades."],
      ["Mesures de seguretat", "EYE STAR SL es compromet a adoptar les mesures tècniques i organitzatives necessàries, d'acord amb el nivell de risc dels tractaments realitzats, de manera que en garanteixin la integritat, confidencialitat i disponibilitat."],
    ]},
    cookies: { title: "Política de cookies", sections: [
      ["Què són", "Les cookies són petits arxius que s'emmagatzemen al vostre dispositiu en navegar i permeten recordar preferències o mesurar l'ús del lloc."],
      ["Cookies que utilitzem", "Cookies tècniques necessàries per al funcionament (idioma, sessió d'administració i el record de la teva elecció de cookies) i, només amb el teu consentiment, cookies analítiques de Google Analytics 4 (_ga, _ga_*; durada màxima 13 mesos) amb IP anonimitzada per conèixer com s'utilitza el web i millorar-lo."],
      ["Tercers", "El mapa integrat de Google Maps i el motor de reserves extern poden instal·lar les seves pròpies cookies, subjectes a les seves polítiques."],
      ["Com gestionar-les", "Podeu configurar el vostre navegador per bloquejar o eliminar cookies. Això pot afectar algunes funcionalitats del lloc."],
      ["Gestionar el teu consentiment", "En entrar per primera vegada pots acceptar, rebutjar o configurar les cookies per categories. Pots canviar la teva elecció en qualsevol moment des de l'enllaç «Configurar cookies» del peu de pàgina. Si rebutges les cookies analítiques, Google Analytics funciona en mode sense cookies (Consent Mode) i només rep senyals anònims."],
    ]},
    updated: "Última actualització",
  },
  consent: {
    eyebrow: "Cookies",
    title: "La teva privacitat, a la teva manera",
    text: "Fem servir cookies pròpies necessàries i, només si ho acceptes, cookies analítiques (Google Analytics) per entendre com s'utilitza el web i millorar-lo. Pots canviar la teva elecció quan vulguis des de «Configurar cookies», al peu de pàgina.",
    more: "Política de cookies",
    acceptAll: "Acceptar-les totes",
    reject: "Rebutjar",
    configure: "Configurar",
    save: "Desar selecció",
    close: "Tancar",
    always: "Sempre actives",
    necessary: { t: "Necessàries", d: "Imprescindibles perquè el web funcioni: idioma, seguretat i el record de la teva elecció de cookies." },
    analytics: { t: "Analítiques", d: "Google Analytics amb IP anonimitzada, per mesurar visites i millorar el web. Si les rebutges, només s'envien senyals anònims sense cookies." },
    marketing: { t: "Màrqueting", d: "Per mesurar campanyes i personalitzar anuncis de Google. Actualment no fem servir cap cookie d'aquest tipus." },
  },
  notFound: { title: "Pàgina no trobada", text: "La pàgina que busqueu no existeix o ha canviat d'adreça.", cta: "Tornar a l'inici" },
  admin: {
    login: "Accés al panell",
    email: "Email",
    password: "Contrasenya",
    enter: "Entrar",
    logout: "Sortir",
    panel: "Panell de continguts",
    tabs: { stats: "Estadístiques", leads: "Sol·licituds", content: "Textos", rooms: "Habitacions", meeting: "Sales", faqs: "FAQs", gallery: "Galeria", blog: "Blog", survey: "Sostenibilitat", settings: "Dades de l'hotel" },
    save: "Desar",
    saved: "Desat",
    add: "Afegir",
    delete: "Eliminar",
    status: { nuevo: "Nou", en_proceso: "En procés", cerrado: "Tancat" },
    noLeads: "Encara no hi ha sol·licituds.",
    resend: "Reenviar avís",
    resendOk: "Avís reenviat a",
    resendFail: "No s'ha pogut enviar l'avís",
    notifySent: "Avís per email enviat",
    notifyFailed: "L'avís per email ha fallat",
    notifyUnknown: "Sense registre d'enviament",
  },
  common: {
    seeMore: "Veure més",
    bookNow: "Reservar ara",
    call: "Trucar a l'hotel",
    placeholderNote: "Fotografia provisional",
  },
  pages: {
    rooms: {
      seoTitle: "Habitacions a Martorell · Doble i Twin de 21 m²",
      seoDesc: "Habitacions Doble i Twin amb wifi de fibra, escriptori i esmorzar bufet. Doble i Doble Twin. Reserva directa al millor preu.",
      heroTitle: ["Habitacions", "pensades per descansar"],
      heroText: "92 habitacions dissenyades per al descans absolut del viatger de negocis i d'oci.",
    },
    roomDetailSuffix: "Habitacions",
    corporate: {
      seoTitle: "Hotel per a empreses i sales de reunions a Martorell",
      seoDesc: "Tarifes corporatives, 3 sales de reunions fins a 180 persones i allotjament a 5 min de SEAT-CUPRA i els polígons de Martorell. Demaneu pressupost en 24 h.",
      heroTitle: ["La vostra base d'operacions", "al corredor del Llobregat"],
    },
    meetingRooms: {
      seoTitle: "Sales de reunions i esdeveniments a Martorell",
      seoDesc: "3 sales amb llum natural de 35 a 220 m² per a reunions, formacions i convencions de 12 a 180 persones. Audiovisuals, fibra i coffee break.",
      heroTitle: ["Tres sales,", "infinits muntatges"],
    },
    events: {
      seoTitle: "Bodes, celebracions i grups a Martorell",
      heroTitle: ["Els grans dies mereixen", "un lloc a l'alçada"],
      stepsTitle: "Tres passos, zero preocupacions",
    },
    restaurant: {
      seoTitle: "Restaurant a Martorell · Cuina mediterrània",
      heroTitle: ["Cuina mediterrània", "de mercat"],
    },
    location: {
      seoTitle: "Ubicació · Hotel a Martorell a 30 min de Barcelona",
      heroTitle: ["Al centre de tot", "el que importa"],
      distancesTitle: "Distàncies i temps",
    },
    gallery: {
      seoDesc: "Fotografies de l'Hotel Ciutat Martorell 4★ a Martorell: habitacions Doble i Twin, banys, sales de reunions, Saló de Banquets, restaurant My Bar, zones comunes i entorn.",
      biosphereNote: "L'Hotel Ciutat Martorell compta amb la certificació Biosphere de turisme sostenible. Consulta totes les nostres accions i compromisos en matèria de sostenibilitat directament al nostre perfil oficial.",
    },
    blog: { seoDesc: "Guies pràctiques sobre Martorell, Barcelona i Montserrat: com arribar en tren o cotxe, què visitar, on menjar i consells per a viatgers d'empresa i famílies." },
    faq: { eyebrow: "Preguntes freqüents", home: "El que ens solen preguntar", rooms: "Sobre les habitacions", corporate: "Sobre reunions i empreses", events: "Sobre casaments, celebracions i grups", restaurant: "Sobre el restaurant" },
    biosphere: { seoTitle: "Sostenibilitat · Certificació Biosphere" },
    contact: { hoursValue: "Check-in 15:00 · Check-out 12:00" },
    seal: { sustainableTourism: "Turisme sostenible", certifiedBy: "Certificació", viewCert: "Veure certificació" },
    bookingCta: {
      eyebrow: "Reserva directa",
      rooms: { title: "Reserva al millor preu garantit", text: "Reservant directament al web oficial aconsegueixes la millor tarifa, sense intermediaris ni comissions." },
      location: { title: "A 30 minuts de Barcelona i Montserrat", text: "Allotja't al costat de les estacions de Renfe i FGC, amb l'aeroport a 30 minuts. Reserva directa al millor preu garantit." },
    },
    blogPost: {
      sidebarTitle: "Dorm a 100 m del tren",
      cta: {
        eyebrow: "Reserva directa",
        secondary: "Demanar pressupost",
        transport: { title: "Dorm a 100 m del tren", text: "Allotja't al costat de les estacions de Renfe i FGC i mou-te per Barcelona en 30 minuts. Millor preu garantit al web oficial." },
        guides: { title: "La teva base per descobrir Martorell", text: "Barcelona, Montserrat i l'aeroport a 30 minuts. Reserva directa i comença a planejar la teva escapada." },
        business: { title: "Allotjament i sales per a la teva empresa", text: "A 5 minuts de la zona industrial, amb sales de reunions i tarifa d'empresa. Demana'ns un pressupost a mida." },
        default: { title: "Reserva la teva estada a Martorell", text: "Hotel 4★ a 30 minuts de Barcelona. Millor preu garantit reservant directament." },
      },
    },
    homeHeadings: {
      presentation: ["Hotel 4 estrelles a Martorell.", "Descans, feina i celebracions", "a 30 minuts de Barcelona."],
      gastronomy: ["Cuina mediterrània", "de mercat, sense presses"],
      extras: ["Un esdeveniment, una reunió", "o una estada llarga?"],
      heroRooms: "Habitacions",
    },
  },
};

export default ca;
